import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import TpsAccessSplash from "@/components/TpsAccessSplash";
import { Button } from "@/components/ui/button";

// Only the default entry resolves HQ membership. /app/owner stays an explicit
// Studio destination, including its existing setup and commercial terms gates.
export default function OwnerLanding() {
  useUiLanguage();
  const { user, studio } = useAuth();
  const identity = `${user?.id || ""}:${studio?.id || ""}`;
  const [result, setResult] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setResult(null);
    api.get("/brand/context").then(context => {
      if (!Array.isArray(context?.brands)) throw new Error(tr("Invalid Brand context"));
      const destination = context.brands.some(brand => brand.role === "brand_admin")
        ? "/hq" : "/app/owner";
      if (active) setResult({ identity, destination });
    }).catch(() => {
      if (active) setResult({ identity, error: true });
    });
    return () => { active = false; };
  }, [identity, attempt]);

  if (!result || result.identity !== identity) return <TpsAccessSplash />;
  if (result.error) return <div role="alert" className="space-y-3 p-6">
    <p>{tr("Non siamo riusciti a caricare il tuo spazio di lavoro. Riprova.")}</p>
    <Button onClick={() => { setResult(null); setAttempt(value => value + 1); }}>{tr("Riprova")}</Button>
  </div>;
  return <Navigate to={result.destination} replace />;
}
